import Vue from 'vue';

//bootstrap plug-in
import BootstrapVue from 'bootstrap-vue/esm/index.js';
import 'bootstrap-vue/dist/bootstrap-vue.css';

//common plug-ins

//axios
import axios from 'axios';
import VueAxios from 'vue-axios';

//Auth
import AuthManager from './auth/index';

//vuelidate
import Vuelidate from 'vuelidate';
import VuelidateErrorExtractor from 'vuelidate-error-extractor';

//vue inline svg
import { InlineSvgPlugin } from 'vue-inline-svg';

//other
import { sync } from 'vuex-router-sync';
import VueProgressBar from 'vue-progressbar';
import Toasted from 'vue-toasted';

//DataTables
import $ from 'jquery';
import dt from 'datatables.net-bs4';
dt.apply($, window, $);

import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import VueDataTables from 'vue-datatables.net';

//router and store
import router from './router';
import store from './store';

//components
import app from 'components/app';
import validationSummary from 'components/common/validation-summary';
import vuelidateErrorExtractorTemplate from 'components/common/vuelidate/bootstrap4-template';
import VueDataTablesFilterInput from 'components/common/vue-datatables/filters/filter-input';
import VueDataTablesFilterDateRange from 'components/common/vue-datatables/filters/filter-daterange';
import VueDataTablesFilterCheckbox from 'components/common/vue-datatables/filters/filter-checkbox';
import VueDataTablesFilterSelect from 'components/common/vue-datatables/filters/filter-select';
import VueDataTablesFilterInputAutocomplete from 'components/common/vue-datatables/filters/filter-input-autocomplete';
import VueDataTableDefaults from 'components/common/vue-datatables/defaults';
import DefaultLayout from "components/layouts/default";
import AuthorizedLayout from "components/layouts/authorized";
import SvgIcon from "components/common/svg-icon";
import HorizontalStepper from "components/common/horizontal-stepper";
import UploadFile from "components/common/upload-file";
import FormInputPassword from 'components/common/forms/form-input-password';
import FormInputFormatted from 'components/common/forms/form-input-formatted';
import FormInputDecimal from 'components/common/forms/form-input-decimal';
import FormSelect from 'components/common/forms/form-select';

import Autocomplete from 'v-autocomplete';
import 'v-autocomplete/dist/v-autocomplete.css';

import Select from "components/common/select";
import DatePicker from "components/common/datepicker";

import { Plugin } from 'vue-fragment';
import userData from '@/filters/user.js';

Vue.use(router);
sync(store, router);

Vue.use(BootstrapVue);

axios.defaults.baseURL = '/server';
Vue.use(VueAxios, axios);

Vue.use(AuthManager, { router: router });

Vue.use(Vuelidate);

Vue.use(VuelidateErrorExtractor, {
  name: 'v-form-group',
  template: vuelidateErrorExtractorTemplate,
  messages: {
    required: 'The {label} field is required.',
    between: 'The {label} field need to be in range {min} - {max}.',
    email: 'The {label} field should be a valid email.',
    password: 'Password must contain at least 12 characters including 1 lowercase letter, 1 capital letter, 1 number, and 1 special character. No spaces, please.',
    confirmPassword: 'The passwords should match.',
    minLength: 'The {label} must be at least {min} characters long.',
    isAdult: 'We’re sorry. We are only able to provide an accurate diabetic risk assessment to people 18 years of age or older.',
    minValue: 'The {label} must be at least {min}.',
    numeric: 'The {label} must be a number.',
    decimal: 'The {label} must be a number.',
    alphaNum: 'The {label} can only contain letters and numbers',

    anyOptionRequired: 'You need to select at least one option',
    requiredStripeElement: 'The {label} field is required.',
    percentIf: 'Please enter valid percent value.',
    atLeastOneDate: 'At least one date is required',
    atLeastOneEthninity: 'At least one ethninity is required'
  }
});

Vue.use(VueProgressBar, {
  color: '#2dc2bd',
  thickness: '.25rem'
});

Vue.use(VueDataTables, VueDataTableDefaults);

Vue.use(Toasted, {
  theme: "bubble",
  position: "top-center",
  iconPack: 'fontawesome',
  duration: 1500
});

Vue.use(InlineSvgPlugin);
Vue.use(Autocomplete);
Vue.use(Plugin);

Vue.component('validation-summary', validationSummary);

Vue.component('dt-filter-input', VueDataTablesFilterInput);
Vue.component('dt-filter-daterange', VueDataTablesFilterDateRange);
Vue.component('dt-filter-checkbox', VueDataTablesFilterCheckbox);
Vue.component('dt-filter-select', VueDataTablesFilterSelect);
Vue.component('dt-filter-input-autocomplete', VueDataTablesFilterInputAutocomplete);

Vue.component('date-picker', DatePicker);

Vue.component("default-layout", DefaultLayout);
Vue.component("authorized-layout", AuthorizedLayout);
Vue.component("svg-icon", SvgIcon);
Vue.component("horizontal-stepper", HorizontalStepper);
Vue.component("v-select", Select);
Vue.component("upload-file", UploadFile);
Vue.component("form-input-password", FormInputPassword);
Vue.component("form-input-formatted", FormInputFormatted);
Vue.component("form-input-decimal", FormInputDecimal);
Vue.component("form-select", FormSelect);

Vue.filter('userData', userData);

new Vue({
  el: '#app',
  store,
  router,
  ...app
});